// apps/client/src/ui/screens/hud.tsx (M0-T18) — the in-town HUD: the base layer of phase `inTown` (contract change 10), an
// `overlay` screen so the world stays visible. Only its buttons take pointer events (.hit); the rest of the screen is the world.
import { ActionPad } from '../hud/ActionPad';
import { Banner } from '../hud/Banner';
import { ClockPill } from '../hud/ClockPill';
import { Controls } from '../hud/Controls';
import type { ScreenDef } from '../router';

declare module '../router' { interface ScreenParams { hud: undefined } }

function Hud() {
  return (
    <div className="hud" style={{ position: 'absolute', inset: 0 }}>
      <ClockPill />
      <Controls />
      <ActionPad />
      <Banner />
    </div>
  );
}
export const screen: ScreenDef<'hud'> = { id: 'hud', layer: 'overlay', component: Hud };
